import { ElementLoaderService } from '../loading/services/element-loader.service'
import { ComponentType } from '@angular/cdk/overlay'

export const getComponents =
  (elementLoaderService: ElementLoaderService, components: ComponentType<any>[]): Record<string, ComponentType<any>> => {
    return components.reduce((acc: Record<string, ComponentType<any>>, component: ComponentType<any>) => {
      const selector: string = elementLoaderService.getComponentSelector(component)
      acc[selector] = component
      return acc
    }, {})
  }
